
import dust from "dustjs-linkedin";


(function(){dust.register("widgets/loader",body_0);function body_0(chk,ctx){return chk.write("<div class=\"loader ").reference(ctx.get(["modifier"], false),ctx,"h").write("\"><div class=\"bounce1\"></div><div class=\"bounce2\"></div><div class=\"bounce3\"></div></div>");}return body_0;})();

export default 0;
